export const DATE_WHEN_ONE_MONTH_FREE_SHIPPING_APPLIED = new Date('2022-08-19T00:00:00+0000');
export const DATE_WHEN_ONE_MONTH_FREE_SHIPPING_REMOVED = new Date('2022-10-23T00:00:00+0000');
